import { useStateValue } from '../hooks/UseStateValue';
import { ValidationContext, IValidationContextProps } from '../context/ValidationContext';
import { useCallback, useMemo } from 'react';
import { TProvider, Selection, ProductPage } from '../interfaces/interfaces';

const isBoolean = (val: unknown) => 'boolean' === typeof val;

const getInvalidPageFields = (
    fieldValidation: Record<string, boolean | undefined>,
    selection: Selection,
    page: ProductPage
) => {
    // if a field has a value but validation is undefined, it probably means page was reloaded and a cached value is used. We then "pretend" it is valid.
    // to be saved in cache, a field HAS to validate = true (if required)
    const fields = page.validateFields?.map((fieldKey: string) => {
        return {
            fieldKey,
            valid: isBoolean(fieldValidation[fieldKey])
                ? fieldValidation[fieldKey]
                : selection[fieldKey] === 0 || !!selection[fieldKey]
        };
    });
    return fields?.filter((k) => !k.valid).map((k) => k.fieldKey) ?? [];
};

const ValidationProvider = ({ children }: TProvider) => {
    const [{ fieldValidation, selection }] = useStateValue();

    const invalidFields = useCallback(
        (page: ProductPage) => {
            const fields = getInvalidPageFields(fieldValidation, selection, page);
            return fields;
        },
        [fieldValidation, selection]
    );

    const items: IValidationContextProps = useMemo(
        () => ({
            invalidFields
        }),
        [invalidFields]
    );

    return <ValidationContext.Provider value={items}>{children}</ValidationContext.Provider>;
};

export default ValidationProvider;
